export default __webpack_public_path__ + "static/media/portada_DanielaViloria.0a9b99aa.jpg";